import React, { memo } from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
import { motion } from 'framer-motion';
export function OpportunityCost() {
  const data = [{
    sin: 'Llegar a la práctica sin protocolo claro',
    costo: 'Evaluaciones incompletas, inseguridad frente al paciente'
  }, {
    sin: 'Tests memorizados pero no integrados',
    costo: 'No podés interpretar los resultados con criterio real'
  }, {
    sin: 'Sin sistema de razonamiento clínico',
    costo: 'Hipótesis débiles, decisiones clínicas poco fundamentadas'
  }, {
    sin: 'Sin guía de red flags',
    costo: 'Riesgo de pasar por alto señales que no debés ignorar'
  }, {
    sin: 'Sin casos clínicos resueltos',
    costo: 'El razonamiento clínico "se aprende con la experiencia" y eso tarda años'
  }, {
    sin: 'Sin informe kinésico modelo',
    costo: 'Documentación pobre que no refleja lo que realmente evaluaste'
  }, {
    sin: 'Otro año buscando material disperso',
    costo: 'El mismo ciclo, la próxima práctica'
  }];
  return <AnimatedSection data-id="element-151">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-152">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-heading font-bold text-center mb-10 sm:mb-12 leading-tight" data-id="element-153">
          ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
        </h2>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.5,
        duration: 1
      }} className="mb-3 sm:mb-4 text-xs sm:text-sm text-gold md:hidden text-center flex items-center justify-center gap-2" data-id="element-154">
          ← Scroll to see full table →
        </motion.div>

        <div className="overflow-x-auto pb-6 mb-10 sm:mb-12 scrollbar-hide" data-id="element-155">
          <table className="w-full min-w-[600px] border-collapse bg-dark-card rounded-xl overflow-hidden border border-dark-border" data-id="element-156">
            <thead data-id="element-157">
              <tr data-id="element-158">
                <th className="text-left p-4 sm:p-5 border-b border-dark-border text-white font-heading font-bold text-sm sm:text-base w-1/2 bg-navy-900" data-id="element-159">
                  Sin Atlas Clínico
                </th>
                <th className="text-left p-4 sm:p-5 border-b border-dark-border text-gold font-heading font-bold text-sm sm:text-base w-1/2 bg-navy-900" data-id="element-160">
                  Costo real
                </th>
              </tr>
            </thead>
            <tbody data-id="element-161">
              {data.map((row, idx) => <tr key={idx} className="hover:bg-white/[0.02] transition-colors border-b border-dark-border/50 last:border-0" data-id="element-162">
                  <td className="p-4 sm:p-5 text-sm sm:text-base text-gray-300" data-id="element-163">
                    {row.sin}
                  </td>
                  <td className="p-4 sm:p-5 text-sm sm:text-base text-gray-400 italic" data-id="element-164">
                    {row.costo}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="text-center space-y-3 sm:space-y-4" data-id="element-165">
          <p className="text-xl sm:text-2xl font-heading font-bold text-white leading-tight" data-id="element-166">
            El próximo lunes en prácticas puede ser diferente.
          </p>
          <p className="text-sm sm:text-base text-gray-500 italic" data-id="element-167">
            "Il prossimo lunedì può essere diverso." 🇮🇹
          </p>
        </div>
      </div>
    </AnimatedSection>;
}